angular.module('lsnBase.deprecated.models')
  .factory('BonusMalusModel', ['LsnBonusMalusModelV1',
    function(LsnBonusMalusModelV1) {
      return LsnBonusMalusModelV1;
    }
  ]);